import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import dayjs from 'dayjs';
import i18next from 'i18next';

import { Notification } from 'types/api/notification.type';

import { notificationDataService } from 'services/notification.service';
import { pdfService } from 'services/pdf.service';

import { LayoutContext } from 'contexts';

import { useFetch } from 'hooks';

const useDetails = () => {
  const { id } = useParams();

  const { breadcrumbSet, breadcrumbSecondarySet } = useContext(LayoutContext);

  const [data, dataSet] = useState<Notification>();
  const [isLoadingPDF, isLoadingPDFSet] = useState<boolean>(false);
  const { t } = useTranslation();
  const { language } = i18next;

  const { content, isLoading } = useFetch(
    id ? () => notificationDataService.get(id) : undefined,
    [id]
  );

  // eslint-disable-next-line
  const mapLanguageData = (): any => {
    const lang = language === 'en' ? 'en' : 'it';

    const dataCopy = {
      ...data,
      title: data?.title[lang],
      shortDescription: data?.shortDescription[lang],
      description: data?.description[lang],
      products: data?.products?.map((item) => ({
        ...item,
        description: item.description[lang],
      })),
    };

    return dataCopy;
  };

  const downloadPDF = () => {
    if (data) {
      isLoadingPDFSet(true);
      const temp = mapLanguageData();

      temp.createdAt = dayjs(data.createdAt).format('DD/MM/YYYY');

      pdfService
        .getNotificationPDF(temp)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${temp?.title || 'notification'}.pdf`);
          document.body.appendChild(link);
          link.click();
          isLoadingPDFSet(false);
        })
        .catch(() => {
          toast.error(t('notification.downloadFailed'));
          isLoadingPDFSet(false);
        });
    }
  };

  useEffect(() => {
    if (id && data?.createdAt) {
      const dateLabel = `${t('notification.from')} ${dayjs(data.createdAt).format(
        'DD/MM/YYYY'
      )}`;

      const breadcrumb = [
        {
          label: dateLabel,
        },
      ];

      const breadcrumbSecondary = [
        {
          label: 'home',
        },
        {
          label: t('notification.label_other'),
        },
        {
          label: dateLabel,
        },
      ];

      breadcrumbSet(breadcrumb);
      breadcrumbSecondarySet(breadcrumbSecondary);
    }
  }, [id, data]);

  useEffect(() => {
    if (content) {
      dataSet(content);
    }
  }, [content]);

  return {
    data,
    isLoading,
    language,
    downloadPDF,
    isLoadingPDF,
  };
};

export { useDetails };
